module.exports = __webpack_public_path__ + "static/media/sistema-em-rede2.27eaa57e.png";